import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const cancelarAssinaturaService = async (
  assinaturaId: number,
  inativarAnuncios: boolean
) => {
  const token = validateToken();

  if (!token) {
    throw new Error("Não foi possível validar a sessão do usuário.");
  }

  const url = `${Globais.DOMINIOBACK}/assinatura/${assinaturaId}/cancelamento`;

  await axios.patch(
    url,
    { inativarAnuncios },
    { headers: { Authorization: token.AuthStr } }
  );
};
